// actions.js
export const setSelectedDestination = (destination) => ({
    type: 'SET_SELECTED_DESTINATION',
    payload: destination,
  });
  